export class DispatchGroup {
    id = null;

    name = '';

    active = true;
}
